import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FireInsuranceCompany } from '@models/brokerage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-fire-insurance-company',
	templateUrl: './edit-fire-insurance-company.component.html',
	standalone: false,
})
export class EditFireInsuranceCompanyComponent {
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	public fireInsuranceCompany: FireInsuranceCompany;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private matterDispatch: MatterDispatch,
	) {
		this.fireInsuranceCompany =
			this.router.getCurrentNavigation()?.extras?.state?.fireInsuranceCompany;

		if (!this.fireInsuranceCompany) {
			this.navigationService.goBack(this.route);
		}
	}

	_onSubmit(fireInsuranceCompany: FireInsuranceCompany) {
		this.matterDispatch.CreateFireInsuranceCompany(
			this.matterId,
			fireInsuranceCompany,
		);
		this.navigationService.goBack(this.route);
	}

	_onCancel() {
		this.navigationService.goBack(this.route);
	}
}
